import React, { useState } from 'react';
import Select from '@/components/atoms/select';
import useDirectDetail from '@/helpers/useDirectDetail';
import { useSelector } from 'react-redux';
import PermissionModal from '@/components/organisms/permission-modal';

interface ProvinceData {
  name: string;
  value: string | number | undefined;
  keyMapping: string;
  id: string;
}

interface TableProps {
  data: ProvinceData[];
}

const SelectProvince: React.FC<TableProps> = ({ data }) => {
  const { handleDirectDetail } = useDirectDetail();
  const userData = useSelector((state: any) => state.userData);
  const [openModal, setOpenModal] = useState(false);
  const selectOption = data?.map((item) => ({
    label: item.name,
    value: item.value,
    id: item.id,
  }));

  const handleChange = (value: any) => {
    const selectedItem = data.find((item) => item.id === value.id);
    if (selectedItem) {
      if (userData?.user?.permission?.isViewDetails)
        handleDirectDetail(
          selectedItem.keyMapping,
          selectedItem.id,
          'local_indicator',
          false,
          false,
          true,
        );
      else
        setOpenModal(true);
    }
  };

  return (
    <React.Fragment>
      <Select
        placeholder="Chọn tỉnh thành cần xem chi tiết"
        style={{ width: 150 }}
        className="local-select"
        options={selectOption}
        onChange={handleChange}
        showSearch
        withIcon={false}
        isMobile={false}
      />
      <PermissionModal
        open={openModal}
        onCancel={() => {
          setOpenModal(false);
        }}
        title="Xem chi tiết dữ liệu tỉnh"
      />
    </React.Fragment>
  );
};

export default SelectProvince;
